import axios from "axios"

let CSRFTOKEN

export const getCSRFToken = async () => {
  if (CSRFTOKEN) {
    return CSRFTOKEN
  }

  const tag = document.querySelector('meta[name="csrf-token"]')
  if (tag) {
    return tag.getAttribute("content")
  }

  const response = await axios.get("/csrf_token", {
    headers: {
      credentials: "same-origin",
      method: "GET",
    },
  })

  if (response.status !== 200) {
    throw new Error(response.status)
  }

  CSRFTOKEN = response.data.csrf_token

  return response.data.csrf_token
}

export const postFormData = async (url, data, onProgress) => {
  const form = new FormData()
  for (let [name, value] of Object.entries(data)) {
    form.append(name, value)
  }

  const result = await post(url, form, onProgress)

  return result
}

export const putFile = async (path, file, headers = {}, onProgress = () => {}) => {
  const form = new FormData()
  form.append("file", file, file.originalname)

  const response = await axios.put(path, form, {
    ...headers,
    onUploadProgress: (progressEvent) => onProgress(progressEvent.loaded),
  })

  return response
}

export const post = async (path, body, headers = {}, onProgress) => {
  const token = await getCSRFToken()
  const response = await axios.post(path, body, {
    headers: {
      ...headers,
      "X-CSRF-Token": token,
    },
    onUploadProgress: onProgress ? (progressEvent) => onProgress(progressEvent.loaded) : null,
  })

  return response
}

export const get = async (path, headers = {}) => {
  const token = await getCSRFToken()

  const response = await axios.get(path, {
    headers: {
      ...headers,
      "X-CSRF-Token": token,
    },
  })

  return response
}
